export default __webpack_public_path__ + "static/media/account.b531baf6.png";